const lbaBoolean = angular.module('app.lbaBoolean', []);

lbaBoolean.controller('lbaBooleanCtrl', require('./lbaBooleanCtrl'));
lbaBoolean.directive('lbaBoolean', require('./lbaBooleanDir'));

export default lbaBoolean;



// WEBPACK FOOTER //
// ./src/components/lbaBoolean/index.js